import appConfig from '@/features/app/constants/app-config';
import legacy_parseAndValidateAccessToken from '@/features/auth/functions/legacy_parseAndValidateAccessToken';
import { _unixToClientTime } from '@/shared/functions/timezone';
import Cookies from 'js-cookie';

export default function getAccessTokenExpiryTime(
  useCookieStorage: boolean,
  enableLegacyTokenStorage: boolean
) {
  if (useCookieStorage) {
    const tokenExpireDate = Cookies.get(appConfig.accessTokenExpireDateKey);
    if (tokenExpireDate) {
      const expiryTime = _unixToClientTime(parseInt(tokenExpireDate));
      return expiryTime;
    }
  }

  if (enableLegacyTokenStorage) {
    const cookie = Cookies.get(appConfig.authTokenKey);
    if (!cookie) return null;
    const token = legacy_parseAndValidateAccessToken(cookie);
    if (!token) return null;
    return _unixToClientTime(token.expiresAt);
  }

  return null;
}
